import { broadcast, broadcastChannels } from '@common/helpers/broadcast';

// FINISHED with no SUCCESS called indicates failure
export const waitForRegularCashoutResponse = () => new Promise((resolve) => {
  const onCashoutSucceed = () => {
    resolve({ success: true });

    // eslint-disable-next-line
    broadcast.removeEventListener(broadcastChannels.ReceiveCashoutFinished, onCashoutFinished);
  };

  const onCashoutFinished = () => {
    resolve({ success: false });

    broadcast.removeEventListener(broadcastChannels.ReceiveCashoutSuccess, onCashoutSucceed);
  };

  broadcast.addEventListener(
    broadcastChannels.ReceiveCashoutSuccess,
    onCashoutSucceed,
    { once: true },
  );

  broadcast.addEventListener(
    broadcastChannels.ReceiveCashoutFinished,
    onCashoutFinished,
    { once: true },
  );
});
